<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 2V3C12 3.55228 12.4477 4 13 4C13.5523 4 14 3.55228 14 3V2H15C16.6569 2 18 3.34315 18 5V15C18 16.6569 16.6569 18 15 18H5C3.34315 18 2 16.6569 2 15V5C2 3.34315 3.34315 2 5 2H6V1C6 0.447715 6.44772 0 7 0C7.55228 0 8 0.447715 8 1V2H6V3C6 3.55228 6.44772 4 7 4C7.55228 4 8 3.55228 8 3V2H12ZM15 7H5C4.44772 7 4 7.44772 4 8V15C4 15.5523 4.44772 16 5 16H15C15.5523 16 16 15.5523 16 15V8C16 7.44772 15.5523 7 15 7ZM8 9C8.55228 9 9 9.44771 9 10V11C9 11.5523 8.55228 12 8 12H7C6.44772 12 6 11.5523 6 11V10C6 9.44771 6.44772 9 7 9H8ZM13 0C13.5523 0 14 0.447715 14 1V2H12V1C12 0.447715 12.4477 0 13 0Z"
      fill="currentColor"
    />
  </svg>
</template>
